import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {Dimensions, Platform, ImageBackground} from 'react-native';
import {getStatusBarHeight} from 'react-native-iphone-screen-helper';

import FastImage from 'react-native-fast-image';

interface LockerProps {
  locked?: boolean;
  current?: boolean;
}

interface ContentItemProps {
  isCurrent?: boolean;
  locked?: boolean;
}

interface UnlockedBadgeProps {
  unlocked?: boolean;
}

const {width: deviceWidth} = Dimensions.get('window');

const HERO_HEIGHT = 300;

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const HeroSection = styled.View`
  height: ${RFValue(HERO_HEIGHT)}px;
  position: relative;
  justify-content: flex-end;
`;

export const BackgroundImage = styled(ImageBackground)`
  width: ${deviceWidth}px;
  height: ${RFValue(HERO_HEIGHT) + RFValue(20)}px;
  position: absolute;
  top: 0;
  left: 0;
`;

export const GradientOverlay = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.35);
`;

export const CarDisplayContainer = styled.View`
  align-items: center;
  justify-content: center;
`;

export const CarImageContainer = styled.View`
  align-items: center;
  justify-content: center;
`;

export const CarImage = styled(FastImage)`
  width: ${RFValue(210)}px;
  height: ${RFValue(210)}px;
`;

export const CarInfoOverlay = styled.View`
  align-items: center;
`;

export const CarTitle = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  text-align: center;
  text-shadow-color: rgba(0, 0, 0, 0.8);
  text-shadow-offset: 0px 2px;
  text-shadow-radius: 8px;
`;

export const CarSubtitle = styled.Text`
  color: rgba(255, 255, 255, 0.9);
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  text-align: center;

  text-shadow-color: rgba(0, 0, 0, 0.6);
  text-shadow-offset: 0px 1px;
  text-shadow-radius: 4px;
`;

export const HighlightText = styled.Text`
  color: ${({theme}) => theme.colors.gold};
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const ProgressSection = styled.View`
  z-index: 20;
  padding: 0 ${RFValue(20)}px;
`;

export const ContentContainer = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
  border-top-left-radius: ${RFValue(24)}px;
  border-top-right-radius: ${RFValue(24)}px;
  padding-top: ${RFValue(12)}px;
  padding-bottom: 1000px;
  margin-bottom: -1000px;
  ${Platform.OS === 'ios'
    ? `
    shadow-color: #000;
    shadow-offset: 0px -8px;
    shadow-opacity: 0.15;
    shadow-radius: 20px;
  `
    : `
    elevation: 20;
  `}
`;

export const DragHandle = styled.View`
  width: ${RFValue(40)}px;
  height: ${RFValue(4)}px;
  background-color: ${({theme}) => theme.colors.border};
  border-radius: ${RFValue(2)}px;
  align-self: center;
  margin-bottom: ${RFValue(20)}px;
`;

export const SectionHeader = styled.View`
  padding: 0 ${RFValue(20)}px;
  margin-bottom: ${RFValue(16)}px;
`;

export const SectionTitle = styled.Text`
  font-size: ${RFValue(18)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(4)}px;
`;

export const SectionLabel = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
`;

export const SectionSubtitle = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
`;

export const SectionNegrito = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.text};
`;

export const ContentList = styled.View`
  gap: ${RFValue(12)}px;
  padding: 0 ${RFValue(20)}px;
`;

export const CarCard = styled.View<ContentItemProps>`
  padding: ${RFValue(4)}px ${RFValue(12)}px;

  flex-direction: column;
  border-radius: ${RFValue(20)}px;
  background-color: ${({isCurrent, theme}) =>
    isCurrent ? 'rgba(16, 185, 129, 0.08)' : theme.colors.background};
  border-width: ${({isCurrent}) => (isCurrent ? 2 : 1)}px;
  border-color: ${({isCurrent, theme}) =>
    isCurrent ? theme.colors.primary : theme.colors.border};
  overflow: hidden;
  position: relative;
`;

export const LockedOverlay = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 10;
  border-radius: ${RFValue(20)}px;
  align-items: center;
  justify-content: center;
`;
export const LockTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  margin-top: ${RFValue(2)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const CarImageWrapper = styled.View`
  position: relative;
  width: ${RFValue(68)}px;
  height: ${RFValue(68)}px;
  align-items: center;
  justify-content: center;
`;

export const StatusBadge = styled.View<UnlockedBadgeProps>`
  position: absolute;
  bottom: ${RFValue(2)}px;
  right: ${RFValue(2)}px;
  width: ${RFValue(24)}px;
  height: ${RFValue(24)}px;
  border-radius: ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.primary};
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-color: ${({theme}) => theme.colors.shape};
  ${Platform.OS === 'ios'
    ? `
    shadow-color: #000;
    shadow-offset: 0px 2px;
    shadow-opacity: 0.2;
    shadow-radius: 4px;
  `
    : `
    elevation: 6;
  `}
`;

export const CurrentBadge = styled.View`
  position: absolute;
  top: ${RFValue(8)}px;
  right: ${RFValue(8)}px;
  background-color: ${({theme}) => theme.colors.primary};
  padding: ${RFValue(3)}px ${RFValue(8)}px;
  border-radius: ${RFValue(15)}px;
`;

export const CurrentBadgeText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const CardData = styled.View`
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-left: ${RFValue(12)}px;
`;

export const CarInfo = styled.View`
  flex: 1;
`;

export const CarName = styled.Text<LockerProps>`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({locked, theme}) =>
    locked ? theme.colors.text : theme.colors.text_dark};
`;

export const CarDescription = styled.Text<LockerProps>`
  font-size: ${RFValue(11)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({locked, theme}) =>
    locked ? theme.colors.text : theme.colors.primary};
`;

export const BenefitsContainer = styled.View<LockerProps>`
  flex-direction: row;

  align-items: center;
  justify-content: center;
`;

export const CarBenefitsTextContainer = styled.View`
  flex-direction: row;
  background-color: ${({theme}) => theme.colors.background_black};
  padding: ${RFValue(4)}px ${RFValue(4)}px;
  border-radius: ${RFValue(12)}px;
  align-items: center;
  justify-content: center;
  ${Platform.OS === 'ios'
    ? `
    shadow-color: #000;
    shadow-offset: 0px 2px;
    shadow-opacity: 0.1;
    shadow-radius: 4px;
  `
    : `
    elevation: 2;
  `}
`;

export const CarBenefitsText = styled.Text<LockerProps>`
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  margin-left: ${RFValue(2)}px;
  line-height: ${Platform.OS === 'android' ? RFValue(10) : undefined}px;
  color: ${({theme}) => theme.colors.gold};
`;

export const CardContent = styled.View`
  flex: 1;
  flex-direction: row;
  align-items: center;
`;

export const ClubBenefitContainer = styled.View<LockerProps>`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({locked}) =>
    locked ? 'rgba(139, 92, 246, 0.08)' : 'rgba(139, 92, 246, 0.12)'};
  padding: ${RFValue(6)}px ${RFValue(12)}px;
  margin: 0 ${RFValue(-12)}px;
  margin-top: ${RFValue(4)}px;
  margin-bottom: ${RFValue(-4)}px;
  border-bottom-left-radius: ${RFValue(18)}px;
  border-bottom-right-radius: ${RFValue(18)}px;
`;

export const ClubBenefitText = styled.Text<LockerProps>`
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({locked}) => (locked ? 'rgba(139, 92, 246, 0.6)' : '#8B5CF6')};
  margin-left: ${RFValue(6)}px;
`;

export const InfoCard = styled.View`
  margin: ${RFValue(8)}px ${RFValue(20)}px ${RFValue(24)}px;
  padding: ${RFValue(24)}px;
  background-color: ${({theme}) => theme.colors.background_secondary};
  border-radius: ${RFValue(20)}px;
`;

export const InfoItem = styled.View`
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: ${RFValue(20)}px;
`;

export const InfoCardIcon = styled.View<{bgColor?: string}>`
  width: ${RFValue(44)}px;
  height: ${RFValue(44)}px;
  border-radius: ${RFValue(14)}px;
  align-items: center;
  justify-content: center;
  background-color: ${({bgColor, theme}) => bgColor || theme.colors.primary};
`;

export const InfoItemContent = styled.View`
  margin-left: ${RFValue(14)}px;
  flex: 1;
`;

export const InfoItemTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(15)}px;
`;

export const InfoDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  margin-top: ${RFValue(4)}px;
  line-height: ${RFValue(18)}px;
`;

export const HeaderContainer = styled.View<{topInset?: number}>`
  position: absolute;
  top: ${({topInset = 0}) =>
    Platform.OS === 'ios'
      ? `${getStatusBarHeight() + RFValue(8)}px`
      : `${RFValue(16) + (topInset > 0 ? topInset : 0)}px`};
  left: ${RFValue(16)}px;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  z-index: 100;
`;

export const LevelBadge = styled.View`
  position: absolute;

  right: ${RFValue(32)}px;
  background-color: rgba(255, 255, 255, 0.2);
  padding: ${RFValue(6)}px ${RFValue(14)}px;
  border-radius: ${RFValue(20)}px;
  border-width: 1px;
  border-color: rgba(255, 255, 255, 0.3);
`;

export const LevelBadgeText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const BackButton = styled.TouchableOpacity`
  width: ${RFValue(35)}px;
  height: ${RFValue(35)}px;
  border-radius: ${RFValue(20)}px;
  background-color: rgba(0, 0, 0, 0.6);
  align-items: center;
  justify-content: center;
`;

export const CurrentCarContainer = styled.View`
  margin: 0 auto;
  margin-top: -${RFValue(80)}px;
  margin-bottom: ${RFValue(12)}px;
  align-items: center;
`;

export const CurrentCarTitle = styled.Text`
  font-size: ${RFValue(28)}px;
  line-height: ${Platform.OS === 'android' ? RFValue(42) : undefined}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.shape};
  text-shadow-color: rgba(0, 0, 0, 0.5);
  text-shadow-offset: 0px 2px;
  text-shadow-radius: 10px;
  text-align: center;
`;

export const CurrentCarDisplay = styled.View`
  align-self: flex-start;
  flex-direction: row;

  justify-content: center;
  padding: ${RFValue(3)}px ${RFValue(3)}px;
  background-color: ${({theme}) => theme.colors.primary};

  border-radius: ${RFValue(20)}px;
  align-items: center;

  ${Platform.OS === 'ios'
    ? `
    shadow-color: #000;
    shadow-offset: 0px 4px;
    shadow-opacity: 0.1;
    shadow-radius: 8px;
  `
    : `
    elevation: 4;
  `}
`;

export const CurrentCarDisplayWrapper = styled.View`
  border-radius: ${RFValue(17.82)}px;

  gap: ${RFValue(12)}px;
  justify-content: center;
  align-items: center;
  padding: ${RFValue(12)}px ${RFValue(16)}px;
  flex-direction: row;
  border: 1.5px solid rgba(255, 255, 255, 0.9);
`;

export const StatValueInfo = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(2)}px;
`;

export const StatCard = styled.View<{variant?: 'primary' | 'gold' | 'dark'}>`
  align-items: center;
  justify-content: center;
`;

export const StatCardValue = styled.Text<{
  variant?: 'primary' | 'gold' | 'dark';
}>`
  font-size: ${RFValue(16)}px;
  margin-bottom: -${RFValue(3)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.shape};
`;

export const StatCardLabel = styled.Text`
  font-size: ${RFValue(9)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.shape};

  text-align: center;
`;

export const CurrentCarInfoCard = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const BaratinhazContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const BaratinhazPerOrder = styled.Text`
  font-size: ${RFValue(13)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.shape};
  margin-left: ${RFValue(4)}px;
`;

export const CurrentCardInfo = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 0 ${RFValue(8)}px;
`;

export const Divider = styled.View`
  width: 1px;
  height: ${RFValue(36)}px;
  background-color: rgba(0, 0, 0, 0.08);
  margin: 0 ${RFValue(8)}px;
`;

export const LockOverlay = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: ${RFValue(30)}px;
  align-items: center;
  justify-content: center;
`;

export const LockIconContainer = styled.View`
  width: ${RFValue(64)}px;
  height: ${RFValue(64)}px;
  border-radius: ${RFValue(32)}px;
  background-color: rgba(0, 0, 0, 0.6);
  align-items: center;
  justify-content: center;
  ${Platform.OS === 'ios'
    ? `
    shadow-color: #000;
    shadow-offset: 0px 4px;
    shadow-opacity: 0.3;
    shadow-radius: 8px;
  `
    : `
    elevation: 8;
  `}
`;

interface CarLabelProps {
  isLocked?: boolean;
}

export const CarLabelText = styled.Text<CarLabelProps>`
  font-size: ${RFValue(18)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({isLocked, theme}) =>
    isLocked ? 'rgba(255, 255, 255, 0.5)' : theme.colors.shape};
  text-align: center;
  margin-top: ${RFValue(8)}px;
  text-shadow-color: rgba(0, 0, 0, 0.8);
  text-shadow-offset: 0px 2px;
  text-shadow-radius: 8px;
`;
